import { defineMessages } from 'react-intl';

export const messages: {
	panelSplitter: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	panelSplitter: {
		id: 'preview-panel-api.resize.label',
		defaultMessage: 'Resize panel',
		description: 'label text for a button that will allow resizing of the preview panel',
	},
});
